<template>
	<div class="user_list_page">

		<a-form layout="inline" style="margin-bottom: 20px;">
			<a-form-item  label="账号">
					<a-input v-model="filterData.keywords"
						placeholder="请输入账号"></a-input>
				</a-form-item>
				<a-form-item label="账号状态">
					<a-select v-model="filterData.enabledStatus" style="width: 150px" class="mr12" placeholder="账号状态"
						@change="getData(1)" show-search option-filter-prop="label" :filter-option="filterOption">
						<a-select-option v-for="(item, index) of options" :key="index" :value="item.value">
							{{ item.label }}
						</a-select-option>
					</a-select>
				</a-form-item>
				<a-form-item  label="账号状态">
					<a-select v-model="filterData.onlineStatus" style="width: 150px" class="mr12" placeholder="登录状态"
						@change="getData(1)" show-search option-filter-prop="label" :filter-option="filterOption">
						<a-select-option v-for="(item, index) of onLineStatusOptions" :key="index" :value="item.value">
							{{ item.label }}
						</a-select-option>
					</a-select>
				</a-form-item>
				<a-form-item >
					<a-button class="mr12" type="primary" @click="toSearch(true)">搜索</a-button>
					<a-button class="mr12" @click="toSearch(false)">清空</a-button>
					<a-button type="primary" @click="toAdd()">新增</a-button>
				</a-form-item>

		</a-form>

		<!--  -->
		<a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
			:loading="loading">
			<template slot="enabledStatus" slot-scope="text, record">
				<div v-if="record.enabledStatus !== null">
					{{ record.enabledStatus ? "启用" : "禁用" }}
				</div>
				<div v-else>-</div>
			</template>

			<template slot="onlineStatus" slot-scope="text, record">
				<div v-if="record.onlineStatus !== null">
					{{ record.onlineStatus ? "在线" : "离线" }}
				</div>
				<div v-else>-</div>
			</template>


			<template slot="action" slot-scope="text, record">
				<div class="flex_center">
					<a-button type="link" @click="toEdit(record)">编辑</a-button>
					<a-button type="link" @click="onChangeStatus(record)">修改账号状态</a-button>
					<a-button type="link" @click="toDelete(record)">删除</a-button>
					<a-button type="link" @click="toSetPass(record)">重置密码</a-button>
				</div>
			</template>
		</a-table>
		<a-modal :title="tipsModel.title" :visible="tipsModel.flag" @ok="tipsModel.onOk"
			@cancel="tipsModel.flag = false">
			<span>
				{{ tipsModel.content }}
			</span>
		</a-modal>
		<a-modal :title="editModel.title" :visible="editModel.flag" width="700px" @ok="editModel.onOk"
			@cancel="editModel.flag = false">
			<a-form-model :model="editModel" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-form-model-item label="账号">
					<a-input v-model="editModel.username" placeholder="请输入账号"></a-input>
				</a-form-model-item>
                <a-form-model-item label="员工姓名">
					<a-input v-model="editModel.nickname" placeholder="请输入员工姓名"></a-input>
				</a-form-model-item>
                <a-form-model-item label="手机号码">
					<a-input v-model="editModel.phone" placeholder="请输入手机号码"></a-input>
				</a-form-model-item>
                <a-form-model-item label="密码">
					<a-input v-model="editModel.password" placeholder="请输入密码"></a-input>
				</a-form-model-item>
                <a-form-model-item label="确认密码">
					<a-input v-model="editModel.passwordRe" placeholder="请输入确认密码"></a-input>
				</a-form-model-item>
				<a-form-model-item label="设置角色">
					<a-select v-model="editModel.roleId" placeholder="请选择角色" show-search option-filter-prop="label"
						:filter-option="filterOption">
						<a-select-option v-for="(item, index) of roleList" :key="index" :value="item.value">
							{{ item.label }}
						</a-select-option>
					</a-select>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	import {
		userListApi,
		userEditApi,
		userDeleteApi,
		enabledStatusApi,
		userSetPassApi,
		roleListApi,
	} from "../../api/index";

	export default {
		name: "userList",
		data() {
			return {
				filterData: {
					keywords: "",
					enabledStatus: null,
					roleId: null
				},
				columns: [{
						title: "账号",
						dataIndex: "username",
						key: "username",
					},
                    {
						title: "员工姓名",
						dataIndex: "nickname",
						key: "nickname",
					},
                     {
						title: "手机号码",
						dataIndex: "phone",
						key: "phone",
					},
                     {
						title: "角色名称",
						dataIndex: "roleName",
						key: "roleName",
					},
                     {
						title: "最近操作时间",
						dataIndex: "operationTime",
						key: "operationTime",
					},
					{
						title: "使用状态",
						key: "enabledStatus",
						scopedSlots: {
							customRender: "enabledStatus"
						},
					},
					{
						title: "操作",
						key: "action",
						width: 200,
						align: "center",
						scopedSlots: {
							customRender: "action"
						},
					},
				],
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				options: [{
						label: "可用",
						value: true,
					},
					{
						label: "禁用",
						value: false,
					},
				],
				onLineStatusOptions: [{
						label: "在线",
						value: true,
					},
					{
						label: "离线",
						value: false,
					},
				],
				tipsModel: {
					flag: false,
					title: "",
					content: "",
					adminId: "",
					username: "",
					roleId: "",
					onOk: () => {},
				},
				editModel: {
					flag: false,
					title: "",
					content: "",
					adminId: "",
					username: "",
					roleId: "",
					onOk: () => {},
				},
				roleList: [],
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 18
				},
			};
		},
		created() {},
		activated() {},
		mounted() {
			const storedQuery = localStorage.getItem('userList_searchQuery');
			if (storedQuery) {
				this.filterData = JSON.parse(storedQuery);
				this.getData(1);
			} else {
				this.getData(1);
			}
		},
		beforeRouteLeave(to, from, next) {
			localStorage.setItem('userList_searchQuery', JSON.stringify(this.filterData));
			next();
		},
		methods: {
			handleBlur() {
				console.log('blur');
			},
			handleFocus() {
				console.log('focus');
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			toSearch(flag) {
				if (flag) {
					this.getData(1);
				} else {
					this.filterData = {
						keywords: "",
						enabledStatus: undefined,
						onlineStatus: undefined
					};
					this.getData(1);
				}
			},
			changePage(page) {
				this.pageInfo.current = page.current;
				this.getData(this.pageInfo.current);
			},
			getData(page = 1) {
				this.pageInfo.current = page;
				if (this.loading) {
					return;
				}
				this.loading = true;
				userListApi({
						pageNo: this.pageInfo.current,
						pageSize: this.pageInfo.pageSize,
						keywords: this.filterData.keywords,
						enabledStatus: this.filterData.enabledStatus,
						onlineStatus: this.filterData.onlineStatus
					})
					.then((res) => {
						if (res.resultStatus) {
							this.tableData = res.resultData.records || [];
							this.pageInfo.total = res.resultData.totalNum || 0;
						} else {
							this.tableData = [];
							this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			onChangeDate() {
				this.getData(1);
			},
			getRoleList() {
				roleListApi().then((res) => {
					if (res.resultStatus) {
						this.roleList = (res.resultData.records || []).map((f) => {
							const obj = {
								label: f.roleName,
								value: f.roleId,
								...f,
							};
							return obj;
						});
					} else {
						this.roleList = [];
					}
				});
			},
			toAdd() {
				this.getRoleList();
				this.editModel = {
					flag: true,
					title: "新增账号",
					content: "",
					adminId: 0,
					username: "",
					roleId: undefined,
					onOk: this.sureEdit,
				};
			},
			toEdit(data) {
				this.getRoleList();
				this.editModel = {
					flag: true,
					title: "编辑账号",
					username:data.username,
					enabledStatus: data.enabledStatus,
					roleId: data.roleId,
					nickname: data.nickname,
                    phone: data.phone,
					adminId:data.adminId,
					onOk: this.sureEdit,
				};
			},
			toDelete(data) {
				this.tipsModel = {
					flag: true,
					title: "删除账号",
					content: "确认要删除账号吗？",
					adminId: data.adminId,
					username: data.username,
					roleId: data.roleId,
					onOk: this.sureDelete,
				};
			},
			toSetPass(data) {
				this.tipsModel = {
					flag: true,
					title: "重置密码",
					content: "确认要重置此账号密码吗？",
					adminId: data.adminId,
					username: data.username,
					roleId: data.roleId,
					onOk: this.sureSetPass,
				};
			},
			onChangeStatus(data) {
				this.tipsModel = {
					flag: true,
					title: "修改账号状态",
					content: data.enabledStatus ?
						"确认要停用此账号吗？" : "确认要恢复该账号吗？",
					adminId: data.adminId,
					username: data.username,
					roleId: data.roleId,
					onOk: this.sureChangeStatus,
				};
			},
			sureChangeStatus() {
				if (this.loading) {
					return;
				}
				this.loading = true;
				enabledStatusApi({
						adminId: this.tipsModel.adminId,
						username: this.tipsModel.username,
						roleId: this.tipsModel.roleId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("修改账号状态成功");
							this.tipsModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.loading = false;
						this.getData(1);
					});
			},
			sureDelete() {
				if (this.loading) {
					return;
				}
				this.loading = true;
				userDeleteApi({
						adminId: this.tipsModel.adminId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("删除账号成功");
							this.tipsModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.loading = false;
						this.getData(1);
					});
			},
			sureEdit() {
				if (!this.editModel.username) {
					this.$message.warning("请输入账号名称");
					return;
				}
				if (!this.editModel.roleId) {
					this.$message.warning("请选择角色");
					return;
				}
				userEditApi({
						adminId: this.editModel.adminId,
						username: this.editModel.username,
						roleId: this.editModel.roleId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success(
								this.editModel.adminId ? "编辑账号成功" : "新增账号成功"
							);
							this.editModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.getData(1);
					});
			},
			sureSetPass() {
				if (this.loading) {
					return;
				}
				this.loading = true;
				userSetPassApi({
						adminId: this.tipsModel.adminId,
						username: this.tipsModel.username,
						roleId: this.tipsModel.roleId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("账号重置密码成功");
							this.tipsModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.loading = false;
						this.getData(1);
					});
			},
		},
	};
</script>

<style lang="less">
	.user_list_page {
		width: 100%;
		height: 100%;
		padding: 20px;
		background: #ffffff;

		.filter_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 12px;
		}

		.mr12 {
			margin-right: 12px;
		}
	}
</style>
